import GoogleLocation from '../../../event_components/google_location';
import { Map } from 'immutable';
import Location from '../../../event_components/location';
import React, { useMemo } from 'react';
import styles from './styles.scss';
import LocationOnIcon from '@mui/icons-material/LocationOn';

export const LocationItem = ({ className, style, event, settings }) => {
  const location = useMemo(
    () =>
      event.get('type') === 'google' ? (
        <GoogleLocation event={event} className={className} style={style} />
      ) : (
        <Location event={event} settings={settings} className={className} style={style} />
      ),
    [event, className, style, settings]
  );

  const venueName = event.getIn(['venue', 'name']);

  const venueNotAvailable = event.get('online_event') || event.get('venue', Map()).isEmpty() || !venueName;
  if (venueNotAvailable) return null;
  return (
    <div className={styles.wrapper}>
      <LocationOnIcon className="location" />
      {location}
    </div>
  );
};
